/** @file Calls the down or up handlers of every onHold subscription for one key code. */
import { keyState } from './keyState';

/** Iterates a copy, so a handler may dispose its own subscription. */
export function fireHolds(code: string, edge: 'down' | 'up'): void {
  for (const hold of keyState.holds.filter((h) => h.code === code)) hold.handlers[edge]();
}
